import { render, staticRenderFns } from "./PlateVolumeChart.vue?vue&type=template&id=2333525b"
import script from "./PlateVolumeChart.vue?vue&type=script&lang=js"
export * from "./PlateVolumeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports